module.exports = __webpack_public_path__ + "img/35.9.TU.138440f3.png";